module.exports = __webpack_public_path__ + "img/Borealus.854b190b.png";